<template>
  <layout-view>
    <template v-slot:tabs>
      <v-tabs v-model="tab" background-color="transparent">
        <v-tab>Рассылка</v-tab>
        <v-tab>История</v-tab>
        <v-tab>Триггерные сообщения</v-tab>
      </v-tabs>
    </template>
    <template v-slot:content="{height}">
      <div v-if="tab===0">
        <distribute-create :height="height"/>
      </div>
      <div v-if="tab===1">
        <distributes :height="height"/>
      </div>
      <div v-if="tab===2">
        <message-trigger :height="height"/>
      </div>
    </template>
  </layout-view>
</template>

<script>

import LayoutView from "@/components/LayoutView.vue";
import {
  Entity_ComContact,
} from "../../../../../EntityStoreCacheService";
import Stater from "@/plugins/stater";
import axios from "axios";
import Api from "@/Api";
import moment from "moment";
import Distributes from "@/views/ContactCenter/Messenger/Distribute/Distributes.vue";
import MessageTrigger from "@/views/ContactCenter/Messenger/Distribute/MessageTrigger.vue";
import DistributeCreate from "@/views/ContactCenter/Messenger/Distribute/DistributeCreate.vue";

export default {
  components: {
    DistributeCreate,
    MessageTrigger,
    Distributes, LayoutView
  },
  props: [],
  data: () => ({
    tab:0,
    name:null,
    text:null,
    textTags:[],
    templateId:null,

    comContactState:new Stater({items:[],count:0}),
    comContact:null,

    previewState:new Stater({items:[],count:0}),
    previewOptions:{},

    delay:15,
    sendDate:null,
    sendTime:null,
    createState:new Stater(),

    usersSelects:[],
  }),
  mounted() {
    this.usersSelects = this.$tools.storageGet('users_selects', []).map(v=>v.id);

    this.sendDate = moment().format('DD.MM.YYYY');
    this.sendTime = moment().format('HH:mm');
    this.load();
  },
  watch:{
    text(){this.preview()},
    comContact(){this.preview()},
    previewOptions(){
      this.preview();
    }
  },
  methods: {
    load(){
      new Entity_ComContact()
          .selects(Entity_ComContact.id)
          .selects(Entity_ComContact.name)
          .selects(Entity_ComContact.messengerType)
          .selects(Entity_ComContact.phone)
          .virtual(Entity_ComContact.virtual_info)
          .order(Entity_ComContact.messengerType, true)
          .addStateCallback((v) => this.comContactState.setRequestBuilderState(v))
          .request()
    },
    preview(){
      if(this.$tools.isEmpty(this.text))
        return;
      this.previewState.stateLoading();
      this.$tools.debounce(() => {
        axios.post(Api.host + '/messenger/distribute/preview/', {
          page: this.previewOptions.page,
          onPage: this.previewOptions.itemsPerPage,
          userIds: this.usersSelects,
          text: this.text,
          textTags: this.textTags,
        }).then((r) => {
          this.previewState.data = r.data;
          this.previewState.stateSuccess()
        }).catch(() => {
          this.previewState.stateError()
        });
      }, 1000);
    },
    create() {
      this.createState.stateLoading()
      axios.post(Api.host + '/messenger/distribute/', {
        name: this.name,
        userIds: this.usersSelects,
        text: this.text,
        textTags: this.textTags,
        templateId: this.templateId,
        delay: this.delay,
        sendDate: moment(this.sendDate+' '+this.sendTime, 'DD.MM.YYYY HH:mm').format('YYYY-MM-DD HH:mm:')+'00',
        comContactId: this.comContact.id,
      }).then(() => {
        this.createState.stateSuccess();
        this.name = null;
        this.text = null;
        this.textTags = [];
        this.templateId = null;
        this.delay = null;
        this.sendDate = null;
        this.sendTime = null;
        this.$store.commit('alertSuccess', 'Успешно создано');
      }).catch(() => {
        this.createState.stateError()
      });
    },
    removeUser(v){
      let usersSelects = this.$tools.storageGet('users_selects', [])
      this.$tools.selectToggle(usersSelects, v)
      this.$tools.storageSet('users_selects', usersSelects)
      this.usersSelects = this.$tools.storageGet('users_selects', []).map(v=>v.id);
      this.preview();
    }
  }
}
</script>